module.exports = __webpack_public_path__ + "alec.3b801040d888c37bd90e.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/alec.jpg
// module id = ../../../../../src/assets/images/alec.jpg
// module chunks = main